import graphql from './graphql';

const query = /* GraphQL */ `
  query User_listPrivateLessons($userId: ID!) {
    User_listPrivateLessons(userId: $userId) {
      id
      lessonId
    }
  }
`;

const UserListPrivateLessons = async ({ userId }) =>
  graphql(query, { userId }).then(
    // eslint-disable-next-line camelcase
    ({ User_listPrivateLessons }) => User_listPrivateLessons
  );

export default UserListPrivateLessons;
